// @flow
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import type { EventType } from 'types/Event';
import { getDateFromString, getMonthName, formatHours } from 'utils/dateUtils';
import { isFfrEvent } from 'utils/eventUtils';

type Props = {
  event: EventType,
  isFirst?: boolean
};

function getVenue(event: EventType) {
  if (isFfrEvent(event)) {
    return (
      event.venue && (
        <span className="event__info">
          <i className="icon icon-place is-inline" />
          {event.venue}
        </span>
      )
    );
  }

  return (
    event.adress && (
      <span className="event__info">
        <i className="icon icon-place is-inline" />
        {event.adress} {event.zip} {event.city}
      </span>
    )
  );
}

function getLink(event: EventType) {
  if (event.redirection) {
    return (
      <a
        href={event.redirection}
        target="_blank"
        title={`Voir le détail de l'événement : ${event.title}`}
        rel="noopener noreferrer"
      >
        {event.title}
      </a>
    );
  }

  return (
    <Link to={`/evenements/${event.slug}`} title={`Voir le détail de l'événement : ${event.title}`}>
      {event.title}
    </Link>
  );
}

const EventListElement = (props: Props) => {
  let { label, categories, startDate, endDate, import_type } = props.event;
  if (categories && categories.length > 0) {
    label = categories.reduce((acc, category) => acc + (acc ? ' - ' : '') + category.name, '');
  }
  const date = getDateFromString(startDate);
  const dateEnd = getDateFromString(endDate);
  let dayStart = `${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
  let monthStart = getMonthName(parseInt(date.getMonth(), 10));
  const monthEnd = getMonthName(parseInt(dateEnd.getMonth(), 10));
  const dayEnd = `${dateEnd.getDate() < 10 ? '0' : ''}${dateEnd.getDate()}`;
  if (!import_type && dayStart !== dayEnd && monthStart === monthEnd) {
    dayStart = `${dayStart} - ${dayEnd}`;
  }
  if (!import_type && monthStart !== monthEnd) {
    dayStart = `${dayStart} | ${dayEnd}`;
    monthStart = `${monthStart} | ${monthEnd}`;
  }

  return (
    <div className="event-row event-row--large">
      <p className="event__date">
        {props.isFirst && (
          <Fragment>
            <span className="event__day ft-h2">{dayStart}</span>
            <br />
            <span className="event__month ft-h6 ft-up">{monthStart}</span>
          </Fragment>
        )}
      </p>
      <div className="event__content">
        <h2 className="event__title ft-h4">{getLink(props.event)}</h2>
        <p>
          {props.event.label && <span className="event__type ft-h6 ft-up">{label}</span>}
          {!props.event.all_day && (
            <span className="event__info">
              <i className="icon icon-clock is-inline" />
              {formatHours(new Date(startDate))}
              {new Date(startDate).getTime() !== new Date(endDate).getTime() && ` - ${formatHours(new Date(endDate))}`}
            </span>
          )}
          {getVenue(props.event)}
        </p>
      </div>
    </div>
  );
};

export default EventListElement;
